export default class {
    constructor(player, playerType) {
        this.player = player;
        this.category = playerType || 'videoEmbed';
        this.title = this.player.getPlaylistItem().title || '';
        this.first = false;
        this.second = false;
        this.third = false;
        this.initialize = false;
    }

    recordEvent(action, label) {
        var category = this.category;
        window.ga('send', 'event', category, action, label, null, {nonInteraction: 1});
        window.ga('rollup.send', 'event', category, action, label, null, {nonInteraction: 1});
    }

    on() {
        this.player.on('time', function (e) {
            var now = Math.round(e.position);
            var firstQ = Math.round(e.duration / 4);
            var secondQ = (firstQ * 2);
            var thirdQ = (firstQ * 3);

            if (!this.initialize) {
                this.initialize = true;
                return this.recordEvent('0%', this.title);
            }

            if (now === firstQ && !this.first) {
                this.first = true;
                return this.recordEvent('25%', this.title);
            }

            if (now === secondQ && !this.second) {
                this.second = true;
                return this.recordEvent('50%', this.title);
            }

            if (now === thirdQ && !this.third) {
                this.third = true;
                return this.recordEvent('75%', this.title);
            }
        }.bind(this));

        jwplayer().on('complete', function () {
            return this.recordEvent('100%', this.title);
        }.bind(this));

        this.player.on('playlistItem', function () {
            this.title = this.player.getPlaylistItem().title || '';
            this.initialize = false;
            this.first = false;
            this.second = false;
            this.third = false;
        }.bind(this));
    }
}
